import { useCallback, useMemo } from 'react';
import { useProjectOrLatestChild } from '@/containers/GroupProject/hooks/useProjectOrLatestChild';
import { getLocationFor } from '@trinity/chat-components/utils';
import { ProjectSurveyResponsesStateContext } from './Context';
import { useMatchResponsesStateFromUrl } from './hooks';
import type { SurveyResponses } from './interfaces';

export const SurveyResponsesStateContainer = (props: ChildrenProps) => {

  const [query, setQuery, resetQueryState] = useMatchResponsesStateFromUrl();

  const state = useProjectOrLatestChild();

  const basePath = useMemo(() => {

    return getLocationFor.project.surveyResponses({ slug: String(state?.id) }).pathname;
  }, [state?.id]);

  const setQueryState = useCallback((data: Partial<Omit<SurveyResponses.QueryState.Value, 'questionId'>>) => {
    setQuery({
      ...data,
      questionId: query.questionId,
      surveyId: query.surveyId,
    }, 'push');
  }, [
    query.questionId,
    query.surveyId,
    setQuery,
  ]);

  const value = {
    basePath,
    query,
    resetQueryState,
    setQueryState,
  };

  return (
    <ProjectSurveyResponsesStateContext.Provider value={value}>
      {props.children}
    </ProjectSurveyResponsesStateContext.Provider>
  );
};

export default SurveyResponsesStateContainer;